import {
  metamask,
  coinbasewallet,
  walletconnect,
} from '@sail/icons/react/BrandIcon';
import type {IconAsset} from '@sail/icons/types';
import {phantom} from 'src/v2/icons/phantom';
import {absurd} from 'src/utils/absurd';
import type {WalletProvider} from 'src/types';

// Map wallet providers to their icons
export const getWalletIcon = (walletProvider: WalletProvider): IconAsset => {
  switch (walletProvider) {
    case 'MetaMask':
      return metamask;
    case 'Phantom':
      return phantom;
    case 'Coinbase Wallet':
      return coinbasewallet;
    case 'WalletConnect':
      return walletconnect;
    default:
      return absurd(walletProvider);
  }
};
